import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { initializeConnection } from './lib/connection';

/**
 * Demo mode: `VITE_DEMO=1`, `?demo=1` or a previously chosen `sornix.demo` flag
 * swaps the API for a seeded local mock, so the entire ERP — including the CCTV
 * matrix, POS and the archive cockpit — can be reviewed without deploying a
 * Worker. It intercepts only `/api/v1/*`; everything else is untouched.
 */
const demoRequested =
  import.meta.env.VITE_DEMO === '1' ||
  new URLSearchParams(window.location.search).has('demo') ||
  localStorage.getItem('sornix.demo') === '1';

async function bootstrap(): Promise<void> {
  await initializeConnection();
  const { App } = await import('./App');
  if (demoRequested) {
    localStorage.setItem('sornix.demo', '1');
    const { installMockFetch } = await import('./lib/mock');
    installMockFetch();
    console.info('[Sornix] demo mode active — API calls are served by the local seed dataset');
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );

  // Offline shell: registered in prod (and on LAN installs where the bridge
  // serves the bundle) so cashiers keep working through a WAN outage.
  if ('serviceWorker' in navigator && !import.meta.env.DEV && !demoRequested) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => void 0);
    });
  }
}

void bootstrap();
